"use client";

import { BrainCircuit, Network, Workflow, ShieldCheck } from "lucide-react";
import ServicePage from "@/components/ServicePage";
import MetadataUpdater from "@/components/MetadataUpdater";
import { serviceSummary } from "@/data/knowledge/services";

export default function AIAutomationPage() {
  return (
    <>
    <MetadataUpdater
      titleKey="meta.solutions.aiAutomation.title"
      description={serviceSummary("ai-automation")}
    />
    <ServicePage
      labelKey="service.ai.label"
      titleKey="service.ai.title"
      descriptionKey="service.ai.description"
      benefits={[
        {
          icon: BrainCircuit,
          titleKey: "service.ai.benefit1.title",
          descKey: "service.ai.benefit1.desc",
        },
        {
          icon: Network,
          titleKey: "service.ai.benefit2.title",
          descKey: "service.ai.benefit2.desc",
        },
        {
          icon: Workflow,
          titleKey: "service.ai.benefit3.title",
          descKey: "service.ai.benefit3.desc",
        },
        {
          icon: ShieldCheck,
          titleKey: "service.ai.benefit4.title",
          descKey: "service.ai.benefit4.desc",
        },
      ]}
      usecaseKeys={[
        "service.ai.usecase1",
        "service.ai.usecase2",
        "service.ai.usecase3",
        "service.ai.usecase4",
        "service.ai.usecase5",
        "service.ai.usecase6",
        "service.ai.usecase7",
        "service.ai.usecase8",
      ]}
      stack={[
        "LangChain",
        "LangGraph",
        "FastMCP",
        "n8n",
        "Ollama",
        "llama.cpp",
        "OpenAI",
        "Anthropic Claude",
        "pgvector",
        "Chroma",
        "Python",
        "TypeScript",
        "Node.js",
        "FastAPI",
        "Webhooks",
        "REST API",
        "Docker",
      ]}
    />
    </>
  );
}
